import React, { Component } from 'react';
import { Back, Power0, TimelineLite } from 'gsap/all';
import { formatNumber } from 'utils/formatting';
import WScoreIcon from 'resources/ui-icon-wscore.png';
import ButtonShine from './assets/SpinBtnHilite.json';
import MultiplierBG from './assets/BehindMultRayburst.json';
import GoodLuck from './assets/GoodLuck.png';
import CheckMarkIcon from './assets/Accessed-Icon-Check.svg';
import DailyBonusBGPurpleEnd from './assets/Purple-BG-End.svg';
import DailyBonusBGPurpleMiddle from './assets/Purple-BG-Middle.svg';
import DailyBonusBGPurpleStart from './assets/Purple-BG-Start.svg';
import DailyBonusBGRedEnd from './assets/Red-BG-End.svg';
import DailyBonusBGRedMiddle from './assets/Red-BG-Middle.svg';
import DailyBonusBGRedStart from './assets/Red-BG-Start.svg';
import './assets/DailyBonus_BehindMultRayburst.png';
import './WScorePopupDisplay.css';

class WScorePopupDisplay extends Component {
  constructor(props) {
    super(props);

    this.state = {
      spinStarted: false,
      drawWinAnim: false
    };

    this.MULTIPLIER_PURPLE_BACKGROUND = [
      DailyBonusBGPurpleStart,
      DailyBonusBGPurpleMiddle,
      DailyBonusBGPurpleEnd
    ];

    this.MULTIPLIER_RED_BACKGROUND = [
      DailyBonusBGRedStart,
      DailyBonusBGRedMiddle,
      DailyBonusBGRedEnd
    ];

    this.renderInteractionArea = this.renderInteractionArea.bind(this);
    this.triggerSpin = this.triggerSpin.bind(this);

    this.multiplierBGData = {
      id: 'multiplierBG',
      options: {
        loop: true,
        autoplay: true,
        animationData: MultiplierBG,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid meet'
        }
      },
      wrapperClass: 'multiplier-bg'
    };

    this.buttonShineData = {
      id: 'buttonShine',
      options: {
        loop: true,
        autoplay: true,
        animationData: ButtonShine,
        rendererSettings: {
          preserveAspectRatio: 'xMinYMin meet'
        }
      },
      wrapperClass: 'button-shine'
    };

    this.timeline = new TimelineLite({ paused: true });
    this.button = null;
    this.text = null;
    this.goodLuck = null;
    this.resultIcon = null;

    this.winTimeline = new TimelineLite({ paused: true });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    // "reset" when parent component has told us win amount is null after having a valid one
    if (
      prevProps.winAmount !== null &&
      prevProps.winAmount >= 0 &&
      this.props.winAmount == null
    ) {
      this.resetAnimations();
    } else if (prevProps.winAmount === null && this.props.winAmount !== null) {
      this.setState({ drawWinAnim: true });
    } else if (this.state.drawWinAnim && !prevState.drawWinAnim) {
      this.fadeGoodLuck();
      this.animateWin();
    }

    if (!prevProps.beginSpin && this.props.beginSpin) {
      this.animateSpinStart();
    }
  }

  getMultiplierImage(position) {
    return this.MULTIPLIER_IMAGES[position - 1];
  }

  getMultiplierBackground(position, isSelected = false) {
    const multiplierBackgroundColor = isSelected
      ? this.MULTIPLIER_RED_BACKGROUND
      : this.MULTIPLIER_PURPLE_BACKGROUND;

    if (position === 1) {
      return multiplierBackgroundColor[0];
    } else if (1 < position && position < 5) {
      return multiplierBackgroundColor[1];
    } else {
      return multiplierBackgroundColor[2];
    }
  }

  createMultiplierList(multiplier) {
    const items = [];

    for (let i = 1; i < 6; i++) {
      let containerClassName = 'multiplier-container';
      if (i === 1 || i === 5) {
        containerClassName += ' edge-multiplier-container'; // first and last container
      }

      if (i < multiplier) {
        items.push(
          <div key={'m' + i + 'accessed'} className={containerClassName}>
            <span className="multiplier-day-streak">{`Day ${i}`}</span>
            <img
              alt={'Multiplier ' + i + ' was accessed'}
              className={'mult-image accessed-multiplier-image'}
              src={CheckMarkIcon}
            />
            <img
              alt={'Multiplier ' + i + ' was accessed'}
              className={'mult-image'}
              src={this.getMultiplierBackground(i)}
            />
          </div>
        );
      } else if (multiplier === i) {
        items.push(
          <div
            key={'m' + i + 'selected'}
            className={`${containerClassName} selected-multiplier-growth`}
          >
            <span className="multiplier-day-streak">{`Day ${i}`}</span>
            <span className="multiplier-value selected-value">{`${i}x`}</span>
            <img
              alt={'Current Multiplier is ' + i}
              className={'mult-image selected-multiplier-image'}
              src={this.getMultiplierBackground(i, true)}
            />
          </div>
        );
      } else {
        items.push(
          <div className={containerClassName} key={'m' + i}>
            <span className="multiplier-day-streak">{`Day ${i}`}</span>
            <span className="multiplier-value">{`${i}X`}</span>
            <img
              className={'mult-image'}
              src={this.getMultiplierBackground(i)}
              alt={'Unused multiplier of ' + i}
            />
          </div>
        );
      }
    }

    return items;
  }

  triggerSpin() {
    this.props.startSpin();
    this.setState({ spinStarted: true });
    this.animateSpinStart();
  }

  animateSpinStart() {
    this.timeline.kill().clear().pause(0);
    this.addGoodLuckSwap();
    this.addInteractiveFade();
    this.timeline.play();
  }

  addGoodLuckSwap() {
    this.timeline.to(
      this.text,
      0.5,
      { opacity: 0, ease: Power0.easeNone },
      '.25'
    );
  }

  addInteractiveFade() {
    this.timeline
      .to(this.multiplierDisplay, 2.35, { top: '-25%' }, '1.25')
      .to(this.disclaimerInfo, 2.35, { top: '-65%' }, '1.25')
      .to(this.goodLuck, 2.0, { opacity: 1, ease: Power0.easeNone }, '1');
  }

  fadeGoodLuck() {
    this.timeline
      .to(this.goodLuck, 1.0, { opacity: 0, ease: Power0.easeNone }, '.2.0')
      .play();
  }

  animateWin() {
    this.winTimeline
      .to(this.result, 0.5, { scale: 1, ease: Back.easeOut.config(1.75) }, '1')
      .to(
        this.resultIcon,
        1,
        { scale: 1, ease: Back.easeOut.config(1.75) },
        '1'
      )
      .to(this.win, 1, { scale: 1, ease: Back.easeOut.config(1.75) }, '1')
      .play();
  }

  resetAnimations() {
    this.winTimeline.restart().kill().clear().pause(0);
    this.timeline.restart().kill().clear().pause(0);
    this.setState({ spinStarted: false, drawWinAnim: false });
  }

  renderInteractionArea() {
    return (
      <div
        className="interactive-result"
        ref={div => this.props.setButtonArea(div)}
      >
        {this.renderWinArea()}
      </div>
    );
  }

  renderActionCall() {
    return (
      <React.Fragment>
        <div className="daily-bonus-sub-title">
          <p>Spin the wheel to earn free </p>
          <img src={WScoreIcon} alt="wscore" />
        </div>
        <br />
        <div className="balance-reload-sub-info">
          Spin the wheel each day to earn WScore just for logging on to play.
          Play multiple days in a row to increase your multiplier and earn even
          more free WScore!
        </div>
        <br />
      </React.Fragment>
    );
  }

  renderWinArea() {
    let winInt = parseInt(this.props.winAmount, 10) * this.props.multiplier;

    return (
      <div className="result-info">
        <div className="result-text" ref={div => (this.result = div)}>
          YOU WON!
        </div>
        <div className="result-icon" ref={div => (this.resultIcon = div)}>
          <img src={WScoreIcon} alt="" />
        </div>
        <div className="result-number" ref={div => (this.win = div)}>
          {
            !isNaN(winInt) && (
              <span>{formatNumber(winInt) + '!'}</span>
            ) /* Don't display NaN */
          }
          <div className="result-breakdown">
            Daily Bonus Reward: {formatNumber(this.props.winAmount)} x{' '}
            {this.props.multiplier}
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="wscore-popup-display">
        <div className="title" ref={this.props.setTitle} />
        <div className="text-area">
          <div
            className="action-call"
            ref={div => {
              this.text = div;
              this.props.setText(div);
            }}
          >
            {this.renderActionCall()}
          </div>

          <div
            className="multiplier-info"
            ref={div => {
              this.disclaimerInfo = div;
              this.props.setDisclaimerInfo(div);
            }}
          >
            <div className="multiplier-header">CONSECUTIVE DAY MULTIPLIER</div>
            <div className="disclaimer">
              Multiplier will reset to 1X on the 1st day of each month.
            </div>
          </div>
          <div className="good-luck" ref={div => (this.goodLuck = div)}>
            <img src={GoodLuck} alt="GoodLuck" />
          </div>
        </div>
        <div
          className="multiplier-display"
          ref={div => {
            this.props.setMultiplier(div);
            this.multiplierDisplay = div;
          }}
        >
          {this.createMultiplierList(this.props.multiplier)}
        </div>
        {this.renderInteractionArea()}
      </div>
    );
  }
}

export default WScorePopupDisplay;
